import { render } from "./HelloI18n.vue?vue&type=template&id=4388f616"
import script from "./HelloI18n.vue?vue&type=script&lang=js"
export * from "./HelloI18n.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./HelloI18n.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Applications/MAMP/htdocs/vue/vue-3-multi-idioma/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__